import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { cartAPI } from "../services/api";
import { useAuth } from "./AuthContext";

const CartContext = createContext(null);
const empty = { items: [], count: 0, subtotal: 0, shipping_fee: 0, total: 0 };

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState(empty);

  const refresh = useCallback(async () => {
    if (!user) {
      setCart(empty);
      return;
    }
    try {
      const data = await cartAPI.get();
      setCart(data);
    } catch (e) {
      console.warn("cart refresh failed", e);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const addToCart = async ({ product_id, size, color, qty = 1 }) => {
    if (!user) {
      const err = new Error("LOGIN_REQUIRED");
      err.code = "LOGIN_REQUIRED";
      throw err;
    }
    const data = await cartAPI.add({ product_id, size, color, qty });
    setCart(data);
    return data;
  };

  const updateQty = async (itemId, qty) => {
    const data = await cartAPI.update(itemId, qty);
    setCart(data);
    return data;
  };

  const removeItem = async (itemId) => {
    const data = await cartAPI.remove(itemId);
    setCart(data);
    return data;
  };

  const clearCart = async () => {
    const data = await cartAPI.clear();
    setCart(data);
    return data;
  };

  return (
    <CartContext.Provider value={{ cart, refresh, addToCart, updateQty, removeItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
